import { style } from 'typestyle'
export const pb8 = style({ paddingBottom: '8px' })
